"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _imageSrc = require("../../lib/imageSrc");
var _utils = require("../../utils");
var _richTextField = require("../../lib/richTextField");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A Hero component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} A jumbotron/hero used in Blog
 */
function BlogHero(props) {
  if (!props.renderingFields) return null;
  var fields = props.renderingFields;
  if (props.renderingFields.PageType.value === 'author') {
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Jumbotron, {
      className: "mm-spacing",
      variant: "dark-secondary"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object reverse"
    }, /*#__PURE__*/_react.default.createElement("picture", {
      className: "mm-img-circle--lg"
    }, !(0, _lodash.isEmpty)(fields.Thumbnail.value) && /*#__PURE__*/_react.default.createElement("img", {
      src: (0, _imageSrc.imageHref)(fields.Thumbnail.value),
      alt: fields.Thumbnail.value.alt
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, !(0, _lodash.isEmpty)(fields.Name.value) && !(0, _lodash.isEmpty)(fields.Credentials.value) && /*#__PURE__*/_react.default.createElement("h1", null, fields.Name.value, ", ", fields.Credentials.value), !(0, _lodash.isEmpty)(fields.Name.value) && (0, _lodash.isEmpty)(fields.Credentials.value) && /*#__PURE__*/_react.default.createElement("h1", null, fields.Name.value), !(0, _lodash.isEmpty)(fields.Bio.value) && /*#__PURE__*/_react.default.createElement("p", null, fields.Bio.value))));
  } else if (props.renderingFields.PageType.value === 'blogTags') {
    var _fields$DisplayTaglin;
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Jumbotron, {
      className: "mm-spacing--minor",
      variant: "dark-secondary"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row reverse"
    }, /*#__PURE__*/_react.default.createElement("section", {
      className: "col-md-12"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "column-label space-below-none"
    }, "Tagged As"), /*#__PURE__*/_react.default.createElement("h1", null, (0, _richTextField.parseHTML)(fields.DisplayTitle)), !(0, _lodash.isEmpty)((_fields$DisplayTaglin = fields.DisplayTagline) === null || _fields$DisplayTaglin === void 0 ? void 0 : _fields$DisplayTaglin.value) && /*#__PURE__*/_react.default.createElement("p", null, (0, _richTextField.parseHTML)(fields.DisplayTagline)))));
  } else if (props.renderingFields.PageType.value === 'blog') {
    var _extractedFields$Vari;
    var extractedFields = (0, _utils.extractFieldsFn)(props);
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Jumbotron, {
      className: "mm-spacing",
      variant: (_extractedFields$Vari = extractedFields.Variant) === null || _extractedFields$Vari === void 0 ? void 0 : _extractedFields$Vari.value,
      backgroundImageUrl: (0, _imageSrc.imageHref)(extractedFields.BackgroundImage.value),
      alt: extractedFields.BackgroundImage.value.alt
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row reverse"
    }, /*#__PURE__*/_react.default.createElement("section", {
      className: "col-md-6"
    }, /*#__PURE__*/_react.default.createElement("h1", null, (0, _richTextField.parseHTML)(extractedFields.Title)), /*#__PURE__*/_react.default.createElement("p", null, (0, _richTextField.parseHTML)(extractedFields.PreviewText)))));
  } else if (props.renderingFields.PageType.value === 'blogcategory') {
    var _extractedFields$Vari2;
    var _extractedFields = (0, _utils.extractFieldsFn)(props);
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Jumbotron, {
      className: "mm-spacing",
      variant: (_extractedFields$Vari2 = _extractedFields.Variant) === null || _extractedFields$Vari2 === void 0 ? void 0 : _extractedFields$Vari2.value,
      backgroundImageUrl: (0, _imageSrc.imageHref)(_extractedFields.BackgroundImage.value),
      alt: _extractedFields.BackgroundImage.value.alt
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row reverse"
    }, /*#__PURE__*/_react.default.createElement("section", {
      className: "col-md-6"
    }, /*#__PURE__*/_react.default.createElement("h1", null, (0, _richTextField.parseHTML)(_extractedFields.Title)))));
  } else {
    return null;
  }
}
var _default = exports.default = BlogHero;